var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 8.33333L2.97976 8.68689L2.62621 8.33333L2.97976 7.97978L3.33331 8.33333ZM17.1666 15C17.1666 15.2761 16.9428 15.5 16.6666 15.5C16.3905 15.5 16.1666 15.2761 16.1666 15L17.1666 15ZM7.14643 12.8536L2.97976 8.68689L3.68687 7.97978L7.85353 12.1464L7.14643 12.8536ZM2.97976 7.97978L7.14643 3.81311L7.85353 4.52022L3.68687 8.68689L2.97976 7.97978ZM3.33331 7.83333L10.6666 7.83333L10.6666 8.83333L3.33331 8.83333L3.33331 7.83333ZM17.1666 14.3333L17.1666 15L16.1666 15L16.1666 14.3333L17.1666 14.3333ZM10.6666 7.83333C14.2565 7.83333 17.1666 10.7435 17.1666 14.3333L16.1666 14.3333C16.1666 11.2958 13.7042 8.83333 10.6666 8.83333L10.6666 7.83333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundArrowLeft);
export default __webpack_public_path__ + "static/media/round-arrow-left.21de90aabc67e589fcaac041b0f2920a.svg";
export { ForwardRef as ReactComponent };